<script>
import CMSSinglePage from "@/views/components/cms/CMSSinglePage.vue";

export default {
  name: "Anwerbung",
  components: {CMSSinglePage},
}
</script>

<template>
 <CMSSinglePage list-element="AnwerbungList"></CMSSinglePage>
</template>

<style scoped>

</style>
